import { Controller } from "@hotwired/stimulus"
import { showOverlay, hideOverlay } from "@/frontend/utils/modalHelpers"

export default class extends Controller {
  static targets = ["dropdown"]
  static values = {
    opened: { type: Boolean, default: false },
  }

  connect() {
    this.bindedClickOutside = (e) => this.clickOutside(e)
  }

  disconnect() {
    document.removeEventListener("click", this.bindedClickOutside)
  }

  open() {
    this.openedValue = true
  }

  clickOutside(e) {
    // Hide a dropdown when liks inside are clicked
    if (["A", "IMG"].includes(e.target.tagName)) return (this.openedValue = false)

    // Don't pass click events to links outside this dropdown
    const isInsideModal = this.dropdownTarget.contains(e.target)
    if (!isInsideModal) e.preventDefault()
    if (isInsideModal) return

    this.openedValue = false
  }

  openedValueChanged() {
    document.removeEventListener("click", this.bindedClickOutside)

    if (this.openedValue) {
      // Listen events only when a dropdown is opened
      setTimeout(() => document.addEventListener("click", this.bindedClickOutside), 500)

      this.dropdownTarget.classList.remove("hidden")
      showOverlay()
    } else {
      this.dropdownTarget.classList.add("hidden")
      hideOverlay()
    }
  }
}
